// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Bq-z","breadcrumbForward":"Cq-z","breadcrumbBack":"Dq-z","selected":"Eq-z"};